
import { Link } from "react-router-dom";

export const Logo = () => {
  return (
    <div className="flex-shrink-0 flex items-center">
      <Link to="/" className="font-montserrat font-bold text-primary text-xl">
        LondonSecondaryGlazing
      </Link>
    </div>
  );
};
